"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/internal_common.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalAccountCoreFan = exports.InternalAccountBrandProfile = exports.InternalAccountPurchasedGoods = exports.InternalAccountSubscribedPlan = exports.InternalTenantCore = exports.InternalTenant = exports.InternalBrandCore = exports.InternalBrand = exports.InternalCreatorCore = exports.InternalCreator = exports.InternalFan = exports.InternalCreatorRole = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.account.v1.InternalCreatorRole
 */
var InternalCreatorRole;
(function (InternalCreatorRole) {
    /**
     * @generated from enum value: INTERNAL_CREATOR_ROLE_UNSPECIFIED = 0;
     */
    InternalCreatorRole[InternalCreatorRole["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: INTERNAL_CREATOR_ROLE_ADMIN = 1;
     */
    InternalCreatorRole[InternalCreatorRole["ADMIN"] = 1] = "ADMIN";
    /**
     * @generated from enum value: INTERNAL_CREATOR_ROLE_OWNER = 2;
     */
    InternalCreatorRole[InternalCreatorRole["OWNER"] = 2] = "OWNER";
    /**
     * @generated from enum value: INTERNAL_CREATOR_ROLE_OPERATOR = 3;
     */
    InternalCreatorRole[InternalCreatorRole["OPERATOR"] = 3] = "OPERATOR";
})(InternalCreatorRole = exports.InternalCreatorRole || (exports.InternalCreatorRole = {}));
// Retrieve enum metadata with: proto3.getEnumType(InternalCreatorRole)
protobuf_1.proto3.util.setEnumType(InternalCreatorRole, "spwn.account.v1.InternalCreatorRole", [
    { no: 0, name: "INTERNAL_CREATOR_ROLE_UNSPECIFIED" },
    { no: 1, name: "INTERNAL_CREATOR_ROLE_ADMIN" },
    { no: 2, name: "INTERNAL_CREATOR_ROLE_OWNER" },
    { no: 3, name: "INTERNAL_CREATOR_ROLE_OPERATOR" },
]);
/**
 * @generated from message spwn.account.v1.InternalFan
 */
class InternalFan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string user_firestore_id = 2;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string email = 4;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalFan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalFan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalFan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalFan, a, b);
    }
}
exports.InternalFan = InternalFan;
InternalFan.runtime = protobuf_1.proto3;
InternalFan.typeName = "spwn.account.v1.InternalFan";
InternalFan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalCreator
 */
class InternalCreator extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string user_firestore_id = 2;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string email = 4;
         */
        this.email = "";
        /**
         * @generated from field: spwn.account.v1.InternalCreatorRole role = 5;
         */
        this.role = InternalCreatorRole.UNSPECIFIED;
        /**
         * クリエイターが所属しているテナント
         *
         * @generated from field: repeated spwn.account.v1.InternalTenantCore belonging_tenants = 6;
         */
        this.belongingTenants = [];
        /**
         * 権限があるブランド
         *
         * @generated from field: repeated spwn.account.v1.InternalBrandCore authorized_brands = 7;
         */
        this.authorizedBrands = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalCreator().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalCreator().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalCreator().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalCreator, a, b);
    }
}
exports.InternalCreator = InternalCreator;
InternalCreator.runtime = protobuf_1.proto3;
InternalCreator.typeName = "spwn.account.v1.InternalCreator";
InternalCreator.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "role", kind: "enum", T: protobuf_1.proto3.getEnumType(InternalCreatorRole) },
    { no: 6, name: "belonging_tenants", kind: "message", T: InternalTenantCore, repeated: true },
    { no: 7, name: "authorized_brands", kind: "message", T: InternalBrandCore, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.InternalCreatorCore
 */
class InternalCreatorCore extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string user_firestore_id = 2;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string email = 4;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalCreatorCore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalCreatorCore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalCreatorCore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalCreatorCore, a, b);
    }
}
exports.InternalCreatorCore = InternalCreatorCore;
InternalCreatorCore.runtime = protobuf_1.proto3;
InternalCreatorCore.typeName = "spwn.account.v1.InternalCreatorCore";
InternalCreatorCore.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalBrand
 */
class InternalBrand extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_firestore_id = 2;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 4;
         */
        this.slug = "";
        /**
         * @generated from field: string description = 5;
         */
        this.description = "";
        /**
         * @generated from field: string icon_thumbnail = 6;
         */
        this.iconThumbnail = "";
        /**
         * @generated from field: string cover_thumbnail = 7;
         */
        this.coverThumbnail = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalBrand().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalBrand().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalBrand().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalBrand, a, b);
    }
}
exports.InternalBrand = InternalBrand;
InternalBrand.runtime = protobuf_1.proto3;
InternalBrand.typeName = "spwn.account.v1.InternalBrand";
InternalBrand.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "icon_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "cover_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "belonging_tenant", kind: "message", T: InternalTenantCore },
]);
/**
 * @generated from message spwn.account.v1.InternalBrandCore
 */
class InternalBrandCore extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_firestore_id = 2;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 4;
         */
        this.slug = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalBrandCore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalBrandCore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalBrandCore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalBrandCore, a, b);
    }
}
exports.InternalBrandCore = InternalBrandCore;
InternalBrandCore.runtime = protobuf_1.proto3;
InternalBrandCore.typeName = "spwn.account.v1.InternalBrandCore";
InternalBrandCore.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalTenant
 */
class InternalTenant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        /**
         * @generated from field: string tenant_firestore_id = 2;
         */
        this.tenantFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: repeated spwn.account.v1.InternalBrandCore owned_brands = 4;
         */
        this.ownedBrands = [];
        /**
         * @generated from field: repeated spwn.account.v1.InternalCreatorCore owned_creators = 5;
         */
        this.ownedCreators = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalTenant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalTenant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalTenant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalTenant, a, b);
    }
}
exports.InternalTenant = InternalTenant;
InternalTenant.runtime = protobuf_1.proto3;
InternalTenant.typeName = "spwn.account.v1.InternalTenant";
InternalTenant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tenant_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "owned_brands", kind: "message", T: InternalBrandCore, repeated: true },
    { no: 5, name: "owned_creators", kind: "message", T: InternalCreatorCore, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.InternalTenantCore
 */
class InternalTenantCore extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        /**
         * @generated from field: string tenant_firestore_id = 2;
         */
        this.tenantFirestoreId = "";
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalTenantCore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalTenantCore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalTenantCore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalTenantCore, a, b);
    }
}
exports.InternalTenantCore = InternalTenantCore;
InternalTenantCore.runtime = protobuf_1.proto3;
InternalTenantCore.typeName = "spwn.account.v1.InternalTenantCore";
InternalTenantCore.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tenant_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountSubscribedPlan
 */
class InternalAccountSubscribedPlan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: int64 started_at = 3;
         */
        this.startedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountSubscribedPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountSubscribedPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountSubscribedPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountSubscribedPlan, a, b);
    }
}
exports.InternalAccountSubscribedPlan = InternalAccountSubscribedPlan;
InternalAccountSubscribedPlan.runtime = protobuf_1.proto3;
InternalAccountSubscribedPlan.typeName = "spwn.account.v1.InternalAccountSubscribedPlan";
InternalAccountSubscribedPlan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "started_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountPurchasedGoods
 */
class InternalAccountPurchasedGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountPurchasedGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountPurchasedGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountPurchasedGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountPurchasedGoods, a, b);
    }
}
exports.InternalAccountPurchasedGoods = InternalAccountPurchasedGoods;
InternalAccountPurchasedGoods.runtime = protobuf_1.proto3;
InternalAccountPurchasedGoods.typeName = "spwn.account.v1.InternalAccountPurchasedGoods";
InternalAccountPurchasedGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.InternalAccountBrandProfile
 */
class InternalAccountBrandProfile extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 3;
         */
        this.slug = "";
        /**
         * @generated from field: string icon_thumbnail = 4;
         */
        this.iconThumbnail = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountBrandProfile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountBrandProfile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountBrandProfile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountBrandProfile, a, b);
    }
}
exports.InternalAccountBrandProfile = InternalAccountBrandProfile;
InternalAccountBrandProfile.runtime = protobuf_1.proto3;
InternalAccountBrandProfile.typeName = "spwn.account.v1.InternalAccountBrandProfile";
InternalAccountBrandProfile.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "icon_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * コアファン (現在プランに加入している or グッズを購入したことがある)
 *
 * @generated from message spwn.account.v1.InternalAccountCoreFan
 */
class InternalAccountCoreFan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.InternalAccountSubscribedPlan subscribed_plans = 2;
         */
        this.subscribedPlans = [];
        /**
         * @generated from field: repeated spwn.account.v1.InternalAccountPurchasedGoods purchased_goods = 3;
         */
        this.purchasedGoods = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalAccountCoreFan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalAccountCoreFan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalAccountCoreFan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalAccountCoreFan, a, b);
    }
}
exports.InternalAccountCoreFan = InternalAccountCoreFan;
InternalAccountCoreFan.runtime = protobuf_1.proto3;
InternalAccountCoreFan.typeName = "spwn.account.v1.InternalAccountCoreFan";
InternalAccountCoreFan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_fan", kind: "message", T: InternalFan },
    { no: 2, name: "subscribed_plans", kind: "message", T: InternalAccountSubscribedPlan, repeated: true },
    { no: 3, name: "purchased_goods", kind: "message", T: InternalAccountPurchasedGoods, repeated: true },
    { no: 4, name: "brand", kind: "message", T: InternalAccountBrandProfile },
]);
//# sourceMappingURL=internal_common_pb.js.map